import React, { useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../../api/api";
import { IProductTypeCreateDto } from "../../../../types/productType.type";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddProductTypeForm: React.FC<Props> = (props) => {
  const [name, setName] = useState<string>("");
  const [description, setDescripton] = useState<string>("");

  const onApply = async () => {
    if (!name) {
      toast.error("Поле тип обовʼязкове");
      return;
    }
    try {
      const body: IProductTypeCreateDto = {
        name,
        description,
      };
      const response = await authApiService.createProductType(body);
      if (response) {
        props.onApply();
        props.onClose();
      }
    } catch (err) {
      console.error(err);
      toast.error("Сталась помилка. Спробуйте пізніше");
    }
  };

  return (
    <div className={styles.container}>
      <form className={styles.form}>
        <EditInput
          value={name}
          setValue={(value) => setName(value)}
          title="Тип"
          isRequired={true}
        ></EditInput>
        <EditInput
          value={description}
          setValue={(value) => setDescripton(value)}
          title="Опис"
          isRequired={false}
          isBig={true}
        />
      </form>
      <ModalBottomButtons
        onPressBack={props.onClose}
        onPressApply={onApply}
        backTitle="Назад"
        applyTitle="Додати тип"
      />
    </div>
  );
};

export default AddProductTypeForm;
